var configService = angular.module('configService',[]);

configService.constant('config',(function(){
	var domain_name = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
	return {
    wedding_id: 0,
    wedding_code: 0,
    logged_in: 0,
    domain: domain_name,
    token: 0,
    vtoken: 0,
    wedding_date: 0,
    S3_URL: 'https://images.wedmegood.com/'
}

})())


